<template>
  <BLayoutExpansion
    :error="$errors.has(name)"
    :error-messages="$errors.first(name)"
    :extendless="extendless"
  >
    <template #header>
      <slot name="header">
        <TitleWithButton
          :title="title"
          :button-text="buttonText"
          :skeleton="skeleton"
          :creatable="!readonly && creatable"
          class="font-weight-bold"
          @create="onActionCreate"
        />
      </slot>
    </template>

    <slot name="top">
      <BAsyncAutocompleteCommon
        v-if="!readonly && typeAutocomplete"
        v-bind="$attrs"
        :$type="typeAutocomplete"
        :value="value"
        :skeleton="skeleton"
        v-on="$listeners || {}"
      />
    </slot>

    <div style="margin: 0 -16px -8px;">
      <BTableCommon
        v-validate="validate"
        v-bind="$attrs"
        :type="typeTable"
        :list="value"
        :actions="filteredActions"
        :skeleton="skeleton"
        :name="name"
        v-on="$listeners || {}"
      >
        <template v-for="(_, key) in scopedSlots" #[key]="props">
          <slot v-bind="props" :name="key" />
        </template>
      </BTableCommon>
    </div>
  </BLayoutExpansion>
</template>

<script>
import uniqueId from 'lodash/uniqueId'
import { CREATE } from '@/helpers/enums/view-types'

import BAsyncAutocompleteCommon from '@/components/forms/BAsyncAutocompleteCommon.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import TitleWithButton from '@/components/common/TitleWithButton.vue'
import BLayoutExpansion from './BLayoutExpansion.vue'


export default {
  name: 'BLayoutExpansionTableAsync',
  inject: ['$validator'],
  components: {
    BLayoutExpansion,
    BAsyncAutocompleteCommon,
    BTableCommon,
    TitleWithButton,
  },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    skeleton: Boolean,
    extendless: Boolean,
    value: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    dataVvAs: String,
    readonly: Boolean,
    creatable: Boolean,
    validate: [String, Object],
    name: {
      type: String,
      default: uniqueId('b-layout-expansion-table-'),
    },
    typeAutocomplete: {
      type: String,
      // required: true,
    },
    typeTable: {
      type: String,
      required: true,
    },
    actions: Array,
    buttonText: {
      type: String,
      default: 'Добавить',
    },
  },
  computed: {
    scopedSlots() {
      const scopedSlots = { ...this.$scopedSlots }
      delete scopedSlots.header
      return scopedSlots
    },
    filteredActions() {
      return this.readonly ? [] : this.actions
    },
  },
  methods: {
    onActionCreate() {
      this.$emit(`action:${CREATE}`)
    },
  },
}
</script>
